import { ImportTargetColumn } from '@app/v2/shared/types/import-target-column.type'
import { InvitationCollectionItem, InvitationCollectionSourceFieldData } from '../types/invitation-tracker.type'

export type InvitationSourceFieldRow = {
  key: string
  label: string
  value: string
}

/**
 * Formats the Source label: "Imported" for imported rows, or the source event name for persona rows.
 * @param item {Pick<InvitationCollectionItem, 'source_type' | 'source_data'>} - Collection item from the API.
 */
export function formatInvitationCollectionSourceLabel(item: Pick<InvitationCollectionItem, 'source_type' | 'source_data'>): string {
  if (item.source_type === 'imported') return 'Imported'
  if (item.source_type === 'persona') return item.source_data?.event_name ?? ''
  return ''
}

/**
 * Builds display rows from the current persona form fields, reading each value from the source data by key.
 * Form fields without a matching source key get an empty value.
 * @param fields {ImportTargetColumn[]} - Current persona form fields (key + label), in form order.
 * @param data {InvitationCollectionSourceFieldData | null | undefined} - Source invitee field bag.
 */
export function buildInvitationSourceFieldRows(fields: ImportTargetColumn[], data: InvitationCollectionSourceFieldData | null | undefined): InvitationSourceFieldRow[] {
  if (!data) return []
  return fields.map(({ field, header }) => ({
    key: field,
    label: header,
    value: String(data[field] ?? '').trim()
  }))
}
